"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
// import { ClosedSession } from '@l2p/profile-api'
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var MobileRow_1 = __importDefault(require("../MobileRow"));
var useClosedSessionsTableData_1 = require("./useClosedSessionsTableData");
var useClosedSessionsMobileData_1 = require("./useClosedSessionsMobileData");
var ClosedSessions = function (_a) {
    var data = _a.data;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var sessionsTableData = (0, useClosedSessionsTableData_1.useClosedSessionsTableData)(data);
    var mobileTableData = (0, useClosedSessionsMobileData_1.useClosedSessionsMobileData)(data);
    return (react_1.default.createElement("div", null,
        Object.keys(breakpoints).length > 0 &&
            !breakpoints.mobile &&
            !breakpoints.tablet && react_1.default.createElement(ui_components_1.DataTable, { data: sessionsTableData }),
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("br", null),
            react_1.default.createElement(ui_components_1.MobileDataTable, { data: mobileTableData, rowComponent: MobileRow_1.default })))));
};
exports.default = ClosedSessions;
